import Vue from 'vue'
import { randomString } from '@/utils/tools'
export default {
  setCurrentPersonInfo(state, value) {
    state.currentPersonInfo = value || {}
  },
  setCurrentAppAuthsInOrg(state, value) {
    state.currentAppAuthsInOrg = value || []
  },
  setCurrentOrg(state, value) {
    state.currentOrg = value
  },
  updateNavPage(state, value) {
    state.updateNavPageFlag = value
  },
  setSelectOrgTree(state, value) {
    state.selectOrgTree = value
  },
  setAppsInOrg(state, value) {
    state.appsInOrg = value
  },
  setCurrentMicroApps(state, value) {
    state.currentMicroApps = value
  },
  setPCCommonData(state, value) {
    state.pcCommonData = value
  },
  setAppsInOrgs(state, value) {
    state.appsInOrgs = value
  },
  setToken(state, val) {
    console.log(val, 'val ssss')
    state.keycloakToken = val
  },
  setTabs(state, val) {
    if (!val || !val.length) {
      let defaultTabs = [
        {
          id: randomString(8),
          title: '首页',
          originRoute: {
            path: '/',
            query: {},
            params: {},
          },
          realRoute: {
            path: '/',
            query: {},
            params: {},
          },
          active: true,
          closeAble: false,
          cachePaths: [],
          history: [],
          isIframe: false,
        },
      ]
      localStorage.setItem('pc:tabs', JSON.stringify(defaultTabs))
      state.tabs = [...defaultTabs]
      console.log('state=>', state)
      return
    }
    localStorage.setItem('pc:tabs', JSON.stringify(val))
    state.tabs = val
  },
  setIframes(state, val) {
    state.iframes = val
  },
  setExternalApp(state, val) {
    state.loadExternalApps = val
    console.log(state.loadExternalApps, '外部应用')
  },
  setLoadedMicroApps(state, val) {
    state.loadedMicroApps = val
  },

  updateTabMenuStatus(state, menuObj) {
    state.tabMenu.status = menuObj.status
    state.tabMenu.top = menuObj.top
    state.tabMenu.left = menuObj.left
    state.tabMenu.list = menuObj.list
  },
}
